import { useCallback, useRef, useState } from 'react';
import { CreditListItem } from '@/components/organisms';
import { ICardInfo, ICardItem } from '@/types';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, SwiperOptions } from 'swiper';
import { clickEventHandler, makeTwoDimensionalArray } from '@/helpers';
import { ButtonOutline } from '@/components/atoms';
import { ButtonWrapper } from './CollectCard.styled';
import { IntersectionObserver } from '@/components/common';
import { useCommonParams, useDeviceId, useLoading } from '@/hooks';
import { COMPONENT_TYPE } from '@/const';
import { useRouter } from 'next/router';

const swiperSettings: SwiperOptions = {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next-card',
  },
  loop: true,
  autoHeight: true,
};

const CollectCard = (props: ICardInfo) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [deviceId] = useDeviceId();
  const [, setLoading] = useLoading();
  const swiperRef = useRef<SwiperRef>(null);
  

  const [activeIndex, setActiveIndex] = useState(1);
  const cardList = makeTwoDimensionalArray(ads, 3);

  const router = useRouter();
  const { ref_event_id } = router.query;

  const handleClickCardItem = useCallback(
    async (item: ICardItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        deviceId,
        componentName: COMPONENT_TYPE.CARD,
      });
    },
    [commonParams, setLoading, deviceId],
  );
  const handleClickNextButton = () => {
    swiperRef.current && setActiveIndex(swiperRef.current.swiper.realIndex + 1);
  };

  return (
    <>
      {ads.length > 3 && (
        <>
          <Swiper
            modules={[Navigation]}
            ref={swiperRef}
            {...swiperSettings}
            onSlideChange={handleClickNextButton}
          >
            {cardList.map((swiperArrayItem: ICardItem[], index) => (
              <SwiperSlide key={`collect-card-${index}`}>
                {swiperArrayItem.map((item: ICardItem, index: number) => (
                  <IntersectionObserver
                    key={`card-item-${index}`}
                    {...item}
                    page={commonParams.page}
                    refEventId={ref_event_id ? ref_event_id as string : ''}
                    componentName={COMPONENT_TYPE.CARD}
                  >
                    <CreditListItem
                      {...item}
                      supportText={ item.supportText }
                      onClick={() => handleClickCardItem(item)}
                    />
                  </IntersectionObserver>
                ))}
              </SwiperSlide>
            ))}
          </Swiper>
          <ButtonWrapper>
            <ButtonOutline className="swiper-button-next-card" full onClick={handleClickNextButton}>
              다음보기 {activeIndex}/<span style={{ color: '#CCCCCC' }}>{cardList.length}</span>
            </ButtonOutline>
          </ButtonWrapper>
        </>
      )}
      {ads.length <= 3 &&
        ads.map((item: ICardItem, index) => (
          <IntersectionObserver
            key={`collect-card-${index}`}
            {...item}
            componentName={COMPONENT_TYPE.CARD}
          >
            <CreditListItem {...item} onClick={() => handleClickCardItem(item)} />
          </IntersectionObserver>
        ))}
    </>
  );
};

export default CollectCard;
